define('presentation/userProfile/bindings/userAvatarMenuBinding',[], function () {
    return {
        init: function (element, valueAccessor) {
            const { hideMenu, togglePresenceMenu } = ko.unwrap(valueAccessor());

            //#region Reposition Popup
            const _repositionUserPresencePopup = () => {
                const menuPosition = userAvatarMenuPopupEl.getBoundingClientRect();
                const popupPosition = userPresencePopupEl.getBoundingClientRect();

                const menuDistanceFromWindowEgde = window.innerWidth - menuPosition.right;

                if (menuDistanceFromWindowEgde < popupPosition.width) {
                    userPresencePopupEl.style.right = menuPosition.width + 'px';
                    userPresencePopupEl.style.left = 'auto';
                }  else {
                    userPresencePopupEl.style.right = 'auto';
                    userPresencePopupEl.style.left = '40px';
                }
            };
            //#endregion

            //#region Outside Click Check
            const _checkIfOutsideMenuClicked = (/** @type { MouseEvent }*/ event) => {
                /** @type { EventTarget }*/
                let clickedElement = event.target;
                do {
                    if (clickedElement === element) {
                        return;
                    }
                    // Go up the DOM
                    clickedElement = clickedElement.parentNode;
                } while (clickedElement);

                hideMenu();
            };
            //#endregion
            
            // #region Mouse Events
            const _onMouseOver = () => {
                togglePresenceMenu(true);
            };

            const _onMouseOut = () => {
                togglePresenceMenu(false);
            };
            // #endregion

            const userAvatarMenuPopupEl = element.querySelector('.user-profile__menu');
            const userPresenceOption = element.querySelector('.user-profile-menu__presence');
            const userPresencePopupEl = element.querySelector('.user-profile-presence__menu');

            _repositionUserPresencePopup();

            window.addEventListener('resize', _repositionUserPresencePopup);
            document.addEventListener('click', _checkIfOutsideMenuClicked);
            userPresenceOption.addEventListener('mouseover', _onMouseOver);
            userPresencePopupEl.addEventListener('mouseover', _onMouseOver);
            userPresenceOption.addEventListener('mouseout', _onMouseOut);
            userPresencePopupEl.addEventListener('mouseout', _onMouseOut);

            ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                window.removeEventListener('resize', _repositionUserPresencePopup);
                document.removeEventListener('click', _checkIfOutsideMenuClicked);
                userPresenceOption.removeEventListener('mouseover', _onMouseOver);
                userPresencePopupEl.removeEventListener('mouseover', _onMouseOver);
                userPresenceOption.removeEventListener('mouseout', _onMouseOut);
                userPresencePopupEl.removeEventListener('mouseout', _onMouseOut);
            });
        }
    };
});
